import React from "react";
import { Row, Col, Image, Modal } from "antd";
import styles from "./index.module.scss";
import MainLayout from "../../components/layout/main-layout";
import bannerImage2 from "../../assets/bgBlack.png";
import bannerImage3 from "../../assets/imprintBanner.png";
import bannerImage from "../../assets/bannerwhite.png";
import bannerImage4 from "../../assets/bgimprint.png";
import { useState } from "react";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import {
  LoveIcon,
  RespectIcon,
  PurposeIcon,
  LaughterIcon,
  LifeIcon,
  SafetyIcon,
  AgeIcon,
  AttentionIcon,
  BusinessIcon,
  SafeIcon,
  MindfulIcon,
} from "../../assets/icons";

const values = [
  {
    title: "Love",
    description:
      "A vibrant celebration of every love story, be that partners, friends, family and all, through acceptance and inclusion without judgement across cultures, abilities and differences.",
    thumbnail: "/Images/love.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Love-COMP-V2.mp4",
    icon: LoveIcon,
    badges: [
      {
        name: "Humanity & Inclusion",
        url: "https://www.humanity-inclusion.org.uk/",
      },
      { name: "Samaritans", url: "https://www.samaritans.org/" },
      {
        name: "Stop Hate UK",
        url: "https://www.stophateuk.org/",
      },
    ],
  },
  {
    title: "Life",
    description:
      "Champion a healthier planet and healthier you through sustainability, conscious choices, and habits that support both personal and environmental well-being.",
    thumbnail: "/Images/life.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Life-COMP-V2.mp4",
    icon: LifeIcon,
    badges: [
      { name: "WaterAid", url: "https://www.wateraid.org/uk" },
      { name: "Friends of the Earth UK", url: "https://friendsoftheearth.uk/" },
      { name: "Doctors Without Borders", url: "https://msf.org.uk/" },
    ],
  },
  {
    title: "Purpose",
    description:
      "Support personal growth through recognition, learning, and self-fulfillment—empowering others to discover and pursue what truly matters to them.",
    thumbnail: "/Images/purpose.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Purpose-COMP-V2.mp4",
    icon: PurposeIcon,
    badges: [
      {
        name: "Room to Read",
        url: "https://www.roomtoread.org/",
      },
      {
        name: "Mental Health Innovations",
        url: "https://mentalhealthinnovations.org/",
      },
      { name: "The Access Project", url: "https://theaccessproject.org.uk/" },
    ],
  },
  {
    title: "Safety",
    description:
      "Promote emotional and physical well-being through spaces to break stigmas, protect rights of all, and inclusive spaces where everyone feels supported and secure.",
    thumbnail: "/Images/safety.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Safety-COMP-V2.mp4",
    icon: SafetyIcon,
    badges: [
      { name: "Oxfam", url: "https://www.oxfam.org.uk/" },
      {
        name: "British Red Cross",
        url: "https://www.redcross.org.uk/",
      },
      { name: "Shelter", url: "https://www.shelter.org.uk/" },
    ],
  },
  {
    title: "Respect",
    description:
      "Honour all forms of life, be that on land, sea or in the air, and seek to build relationships that believe in sharing our planet with compassion and care.",
    thumbnail: "/Images/respect.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Respect-COMP-V2.mp4",
    icon: RespectIcon,
    badges: [
      { name: "WWF (World Wide Fund for Nature)", url: "https://www.wwf.org.uk/" },
      {
        name: "Humanimal Trust",
        url: "https://humanimaltrust.org.uk/",
      },
      { name: "Born Free", url: "https://www.bornfree.org.uk/" },
    ],
  },
  {
    title: "Laughter",
    description:
      "Whether your jokes are so bad they're good or you're a comedic genius, celebrate your inner child with giggles and laughter and share a smile.",
    thumbnail: "/Images/laughter.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Laughter-COMP-V2.mp4",
    icon: LaughterIcon,
    badges: [
      { name: "Papyrus-UK ", url: "https://www.papyrus-uk.org/" },
      { name: "UNICEF", url: "https://www.unicef.org.uk/" },
      { name: "Save the Children", url: "https://www.savethechildren.org.uk/" },
    ],
  },
];

const data = [
  {
    title: "A Mindful Experience",
    icon: MindfulIcon,
    content: (
      <>
        Most social media feels overstimulating, overwhelming, and empty—endless
        scrolling with little meaning. At Imprint, we do things differently.
        Imprint is a network where every post is intentional, every interaction
        respectful, and every user feels empowered. This is a platform designed
        for presence, purpose, and people.
      </>
    ),
  },
  {
    title: "Safety First, Always",
    icon: SafeIcon,
    content: (
      <>
        Most platforms act after the damage is done—removing content only once
        it's been shared, seen, and reported. Social media platforms have been
        used to exploit, organise and spread misinformation resulting in real
        harm. The impact on the UK has been:
        <br />
        <br />
        <strong>2011 England Riots</strong> driven by shocking content and
        misinformation - August 6–11, 2011 - multiple lives lost and injuries
        <br />
        <em>Estimated Cost to Taxpayers:</em> Greater than £100 million in
        claims.
        <br />
        <br />
        <strong>2020-2022 COVID 19 Protests</strong> driven by misinformation -
        The protests resulted in multiple injuries and the spread of the disease
        overwhelming health services.
        <br />
        <em>Estimated Cost to Taxpayers:</em> £several million cost to NHS and
        burden.
        <br />
        <br />
        <strong>2024 Southport Riots</strong> driven by shocking content,
        misinformation and extremism online - July 2024 - multiple injuries and
        unrest.
        <br />
        <em>Estimated Cost to Taxpayers:</em> over £30 million ​in community
        recovery funds.
        <br />
        <br />
        Source:{" "}
        <a
          href="https://assets.publishing.service.gov.uk/media/5a7c686040f0b626628abd77/riot_damages_act_review.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          riot_damages_act_review.pdf
        </a>
        ;{" "}
        <a
          href="https://www.gov.uk/government/publications/community-recovery-fund-guidance/community-recovery-fund-guidance"
          target="_blank"
          rel="noopener noreferrer"
        >
          Community Recovery Fund: Guidance - GOV.UK
        </a>
        <br />
        <br />
        Who paid for the damage and suffered the losses? We did.
        <br />
        Whose fault was it? Social media platforms not tackling misinformation
        and taking down extreme and shocking content fast enough.
        <br />
        The damage was done and we paid, while they profited.
        <br />
        <strong>THIS IS NOT ACCEPTABLE!</strong>
        <br />
        <br />
        On Imprint, every post is reviewed before it goes live. We work with our
        community of changemakers to act quickly so that we can help prevent
        harm before it spreads. This means users can still post spontaneously—we
        just take a moment to keep the space safe. Here, online safety isn’t an
        afterthought. It is the foundation. We try our hardest.
        <br />
        We may make mistakes but who doesn’t, our approach is in the first
        instance to try to keep our community safe and create a better world
        online and offline.
      </>
    ),
  },
  {
    title: "A Business Model for Good",
    icon: BusinessIcon,
    content: (
      <>
        Traditional platforms rely on ads. That means more clicks, more outrage,
        more noise—because your attention is what’s being stolen and sold for
        their profit.
        <br />
        Your attention is <strong>YOURS</strong>. Invest it to make a difference
        and keep it safe.
        <br />
        Attention is the most valuable wealth you have, don’t let someone steal
        it… That's why they want it.
        <br />
        At Imprint, we chose a membership model instead. It’s how we fund our
        platform ethically, enable a safe online space, and stay aligned with
        our values—not algorithms. This means your attention is in your control,
        we let you decide where you want to invest it.
      </>
    ),
  },
  {
    title: "The Attention Dividend",
    icon: AttentionIcon,
    content: (
      <>
        Every post you share is called an imprint—a moment of thought,
        expression, and impact.
        <br />
        But the ripple doesn’t stop there. We use your engagement to understand
        what matters to you—then direct funding to charities aligned with those
        values.
        <br />
        As a community of changemakers, our platform helps you make a difference
        and a better existence for all.
        <br />
        For a small monthly fee, you help power a platform built for people, not
        profit. You’re not just subscribing—you’re becoming a member of
        something better as a portion of every user’s fee is donated to support
        charitable causes.
        <br />
        Your presence on Imprint helps you to be you, do good and feel so good
        about it too!
      </>
    ),
  },
  {
    title: "Designed for Age-Appropriate Use",
    icon: AgeIcon,
    content: (
      <>
        Safety means different things at different ages. That’s why Imprint uses
        age-based content classifications—inspired by standards from the British
        Board of Film Classification (BBFC).
        <br />
        Users under 13 aren’t permitted on the platform, and additional
        safeguards are in place for under-18s, including content filtering and
        moderation checks.
        <br />
        This isn’t about restriction—it’s about responsibility. We’re committed
        to creating a digital space that’s safe, respectful, and right for
        everyone who uses it.
      </>
    ),
  },
];

const impactData = [
  {
    title: "Invest Your Money",
    content: `Your membership powers the platform—funding moderation, development, and charitable impact. This contributes towards better safeguarding as well as dividend payments to the best performing value or charity.`,
  },
  {
    title: "Share Imprints",
    content: `Imprints are your thoughts, stories, and ideas—shared as posts, voice notes, videos, or images depending on your membership tier. By sharing imprints, you deposit your attention against the values or #charities that matter to you.`,
  },
  {
    title: "Support Imprints",
    content: `React to posts that reflect Imprint’s values using value badges or #charities.

When shared in your Personal Tribe, imprints are private and won’t trigger the Attention Dividend—these are for more personal expression.

But in the Global Tribe, every reaction counts. The more an imprint resonates with the community, the more impact it can drive—helping spotlight the causes people care about most.`,
  },
  {
    title: "Deliver an Attention Dividend",
    content: `Your engagement contributes to a ripple effect. You vote for the charities aligned with the values most reflected in the content you support or run #charity campaigns to make a real difference.

Convert your “Attention Impact” to “Real Impact” where a charitable donation is paid from the subscription fee to the value and #charity with the most virality. Virality is the total number of posts AND reactions to a post that has a value badge or #charity. This means either by putting your views out there or even passively scrolling and reacting you’re still able to make a change.`,
  },
];

const AboutUs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const [openModal, setOpenModal] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const showModal = (videoUrl) => {
    setActiveVideo(videoUrl);
    setOpenModal(true);
  };

  return (
    <MainLayout>
      <div id="herobanner">
        <div
          className={styles.heroBanner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <div className={styles.overlay}>
            <h1>Welcome to Imprint.live</h1>
            <p>
              Imprint is a new kind of social network—designed from the ground
              up to be <span className={styles.highlight}>safer</span>,{" "}
              <span className={styles.highlight}>more mindful</span>, and{" "}
              <span className={styles.highlight}>values-driven</span>.
            </p>
            <Image
              src="/Images/featured.png"  
              alt="Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
            />
          </div>
        </div>
      </div>

      {/* <div
        className={styles.sectionWrapper}
        style={{
          background: `url(${bannerImage}) no-repeat center center/cover`,
        }}
      >
      
        <Row gutter={[32, 32]} align="middle" className={styles.block}>
          <Col xs={24} md={12}>
            <h2 className={styles.title}>
              We Believe Social Media Should Support Your
              <span className={styles.highlight}> Well-Being</span>, Not
              <span className={styles.warning}> Compromise It</span>
            </h2>
            <p className={styles.paragraph}>
              That’s why Imprint is built to encourage{" "}
              <strong>authentic self-expression</strong>,
              <strong> respectful interactions</strong>, and{" "}
              <strong>positive impact</strong>—without the noise, pressure, or
              manipulation found on traditional platforms.
            </p>
          </Col>
          <Col xs={24} md={12} className={styles.centerAlignDiv}>
            <Image
              src="/Images/wellbeing.png"
              alt="Well-being Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
            />
          </Col>
        </Row>

       
        <Row gutter={[32, 32]} align="middle" className={styles.block}>
          <Col xs={24} md={12} className={styles.centerAlignDiv}>
            <Image
              src="/Images/moderated.png"
              alt="Moderated Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
              style={{ marginBottom: "-10px" }}
            />
          </Col>
          <Col xs={24} md={12}>
            <h2 className={styles.title}>
              Every Post On Imprint Is
              <span className={styles.highlight}> Pre-Moderated</span> Before It
              Goes Live, Ensuring Your Experience Remains Safe And Intentional.
            </h2>
            <p className={styles.paragraph}>
              This isn’t just social media. It’s a movement to rebuild how we
              connect online.
            </p>
            <p className={styles.paragraph}>
              The future is mindful… the future is Imprint.
            </p>
          </Col>
        </Row>
      </div> */}

      {/* <div
        className={styles.whySection}
        style={{
          background: `url(${bannerImage2}) no-repeat center center/cover`,
        }}
      >
        <h2>Why Imprint?</h2>
        <div className={styles.accordion}>
          {data.map((item, i) => (
            <div
              key={i}
              className={`${styles.accordionItem} ${
                activeIndex === i ? styles.active : ""
              }`}
            >
              <div className={styles.header} onClick={() => toggle(i)}>
                <div className={styles.left}>
                  <Image
                    src={item.icon}
                    alt={`${item.title} icon`}
                    preview={false}
                  />
                  <span>{item.title}</span>
                </div>
                <span className={styles.iconRight}>
                  {activeIndex === i ? <CloseOutlined /> : <PlusOutlined />}
                </span>
              </div>
              {activeIndex === i && (
                <div className={styles.content}>{item.content}</div>
              )}
            </div>
          ))}
        </div>
        <div className={styles.purposeSection}>
          <div className={styles.purposeContainer}>
            <div className={styles.top}>
              <h2>Our Purpose</h2>
              <p>
                We believe the Internet deserves a{" "}
                <strong>“Better BIAS”</strong>. Social media has been shaped by
                power, popularity, and algorithms. It’s left many feeling
                unsafe, unheard, and unseen.
              </p>
              <p>
                At Imprint, we’re shifting the balance by delivering a{" "}
                <strong>“Better BIAS”</strong> which means a place online to{" "}
                <strong>BELONG</strong>, have <strong>IMPACT</strong>, be{" "}
                <strong>AUTHENTIC</strong>, and stay <strong>SAFE</strong>.
              </p>
            </div>

            <div className={styles.grid}>
              <div className={styles.leftBox}>
                <h3>Our Mission</h3>
                <p>
                  To empower every user to inspire, connect, and build hope,
                  through stories that make a difference.
                </p>
                <Image
                  src="/Images/mission.png"
                  alt="Illustration"
                  className={styles.storyImage}
                  loading="lazy"
                  preview={false}
                  width={300}
                  height={200}
                />
              </div>

              <div className={styles.rightImage}>
                <Image
                  src="/Images/purposeimprint.png"
                  alt="Illustration"
                  className={styles.storyImage}
                  loading="lazy"
                  preview={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className={styles.valueBox}>
        <Image
          src="/Images/valuebox.png"
          alt="Illustration"
          loading="lazy"
          preview={false}
        />
      </div>
      <div className={styles.valuesSection}>
        <h2 className={styles.heading}>Our Values</h2>
        <p className={styles.subheading}>
         We have chosen 6 values that make us fundamentally human using Maslow's Hierarchy of Needs. Every imprint you share can reflect these values—and when it does, it gets a Value Badge, helping it reach further and create real-world impact.
        </p>
        <p className={styles.subheading}>
        Through imprints and reactions, Value Badges can start trending. Each Value is associated with three charities, and the users vote which charity the money collected from memberships will support.

        </p>
        <p className={styles.subheading}>
        *Imprint.live has no partnerships with or obligations towards any charities mentioned on this site.
        </p>
        <Row gutter={[24, 24]}>
          {values.map((item, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <div className={styles.card}>
                <div
                  className={styles.thumbnail}
                  style={{ backgroundImage: `url(${item.thumbnail})` }}
                  onClick={() => showModal(item.videoUrl)}
                >
                  <button className={styles.playButton} aria-label="Play Video">
                    ▶
                  </button>
                </div>
                <div className={styles.content}>
                  <Image
                    src={item.icon}
                    alt={`${item.title} icon`}
                    preview={false}
                  />
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <div className={styles.badgeContainer}>
                    <div className={styles.badges}>
                      {item.badges?.map((badge, idx) => (
                        <a
                          key={idx}
                          href={badge.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.badge}
                        >
                          {badge.name}
                          <span className={styles.arrow}>↗</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Modal
          open={openModal}
          footer={null}
          onCancel={() => setOpenModal(false)}
          centered
          width={800}
          className={styles.modal}
          destroyOnClose
        >
          {activeVideo && (
            <div className={styles.videoWrapper}>
              <iframe
                src={`${activeVideo}?autoplay=1&rel=0`}
                title="Value Video"
                frameBorder="0"
                allowFullScreen
                allow="autoplay"
              />
            </div>
          )}
        </Modal>
      </div>

    
      {/* <AuthFooterComponent />
      <span className="app-version">v{process?.env?.version}</span> */}
    </MainLayout>
  );
};

export default AboutUs;
